export {default} from './test-skills.vue'
